// ** Título y subtítulo del header, por ruta.
//
// El rediseño pone un título y un subtítulo en la cabecera de cada pantalla
// (design/BlockPay - Rediseño.dc.html, mapa `titles`). El layout de la plantilla no
// tenía dónde ponerlos: solo había Breadcrumbs, y sueltos dentro de algunas vistas.
//
// Los valores son claves de i18next, no texto. Están en
// src/locales/{sp,eng}/translation.json.
//
// El mapa resuelve por prefijo, así que /legal/disclaimer y /legal/privacy heredan de
// "/legal", y /investment/withdraw hereda de "/investment".

const PAGE_TITLES = {
  "/home": { title: "Home", subtitle: "HomeSubtitle" },
  "/transactions": { title: "Transactions", subtitle: "TransactionsSubtitle" },
  "/transfer": { title: "Transfer", subtitle: "TransferSubtitle" },
  "/block-invest": { title: "Block Invest", subtitle: "BlockInvestSubtitle" },
  "/investment": { title: "Investments", subtitle: "InvestmentsSubtitle" },
  "/faq": { title: "FAQ", subtitle: "FaqSubtitle" },
  "/profile": { title: "Profile", subtitle: "ProfileSubtitle" },
  "/legal": { title: "TermsAndConditions", subtitle: "TermsSubtitle" }
}

// Resuelve por prefijo más largo, para que una futura ruta con parámetro
// (/transactions/:id) herede el título de su padre en vez de quedarse sin cabecera.
export const getPageTitle = (pathname) => {
  if (!pathname) return null

  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname]

  const match = Object.keys(PAGE_TITLES)
    .filter((path) => pathname.startsWith(`${path}/`))
    .sort((a, b) => b.length - a.length)[0]

  return match ? PAGE_TITLES[match] : null
}

export default PAGE_TITLES
